// 顧客宛文書承認（確認）
import React, { useState, useEffect } from 'react';
import { render } from 'react-dom';
import { Row, Col } from 'react-bootstrap';
import axios from '../../axios';
import Moment from 'moment';
import { handleBrowserBack } from '../../BrowserBack';
import LoadingModal from '../../molecules/LoadingModal';
import { document_status } from '../../const/CustomerDocument';
import {
  CustomerDocument,
  CustomersDocumentKWANKGM10060A01,
} from '../../types/CustomerDocumentDetail';
import { document_init } from '../../const/CustomerDocumentDetail';
import { KWANKGM10070A01, KWANKGM10060A01 } from '../../const/api_modules';
import { api_response_type } from '../../Const';
import { CustomerDocumentFileDownload } from './CustomerDocumentFileDownload';

const CustomerDocumentApprovalConfirm = () => {
  // ローディング画面表示状態
  const [is_loading, setIsLoading] = useState(true);
  // URLパラメータの取得
  const url_params = new URLSearchParams(document.location.search.substring(1));
  const document_id = url_params.get('id');
  // 承認確認画面に表示するデータ
  const [document_detail, setDocumentDetail] = useState<CustomerDocument>();
  // ログインユーザIDを取得する
  const node = document.getElementById('customer-document-approval-confirm');
  const login_user_id = node?.dataset.login_user_id;
  const login_user_name = node?.dataset.login_user_name;

  useEffect(() => {
    // ブラウザバック抑止
    handleBrowserBack();
    // 初期表示のリクエスト
    requestModule();
  }, []);

  /**
   * APIへリクエストを行う
   */
  const requestModule = async () => {
    try {
      setIsLoading(true);

      const response = await axios.post(`${location.origin}${process.env.MIX_MOCK_URL}/api/common`, {
        module_name : KWANKGM10060A01,
        is_json : true,
        reception_id : '0',
        reception_cd : null,
        detail : [
          { id: 0, name: 'id', value: document_id },
        ],
      });

      if (!response.data.result) {
        throw({ response: response });
      }

      const data = parseData(response.data.detail.customer_document);

      setDocumentDetail(data);
    } catch (error) {
      console.error(error.response.data.message);
      alert(error.response.data.message);
    } finally {
      setIsLoading(false);
    }
  };

  /**
   * APIレスポンスのdataを分解してstateに格納する
   * @param CustomersDocumentKWANKGM10060A01 data response.data.detail.customers_objectのオブジェクト
   * @returns CustomerDocument Stateにセットするオブジェクト
   */
  const parseData = (data: CustomersDocumentKWANKGM10060A01) => {
    const new_document = document_init;

    new_document.id = data.id;
    new_document.group_name = data.group_name;
    new_document.offices_name = data.offices_name;
    new_document.title = data.title;

    if (data.comment !== null && typeof data.comment !== 'undefined') {
      const jsx_comment: JSX.Element[] = [];
      const splited_comment = data.comment.split('\n');
      splited_comment.map((item, index) => {
        if (index >= 1) {
          jsx_comment.push(<br key={`comment-br-${index}`} />);
        }
        jsx_comment.push(<React.Fragment key={`comment-${index}`}>{item}</React.Fragment>);
      });
      new_document.comment = jsx_comment;
    }

    if (data.file_name !== null && typeof data.file_name !== 'undefined'){
      const jsx_file_name: JSX.Element[] = [];
      jsx_file_name.push(<a className="download" onClick={() => CustomerDocumentFileDownload(Number(document_id), setIsLoading, false)} key="file-name">{data.file_name}</a>)
      new_document.file_name = jsx_file_name;
    }

    if (data.user_list !== null && typeof data.user_list !== 'undefined') {
      const jsx_user_list: JSX.Element[] = [];
      data.user_list.map((user, index) => {
        jsx_user_list.push(
          <Row key={`user-list-${index}`}>
            <Col md={2} key={`user-list-${index}-1`}>{user.user_name}</Col>
            <Col key={`user-list-${index}-2`}>{user.email}</Col>
          </Row>
        );
      });
      new_document.user_list = jsx_user_list;
    }

    new_document.start_date = Moment(data.start_date).format('YYYY-MM-DD');
    new_document.end_date = Moment(data.end_date).format('YYYY-MM-DD');
    new_document.create_user_name = data.create_user_name;
    new_document.authorizer_name = data.authorizer_name;
    new_document.status = document_status[data.status];
    new_document.updated_at = Moment(data.updated_at).format('YYYY-MM-DD');

    return new_document;
  };

  /**
   * 確認ボタン押下時の処理
   */
  const handleClickConfirm = async () => {
    try {
      setIsLoading(true);

      const response = await axios.post(`${location.origin}${process.env.MIX_MOCK_URL}/api/common`, {
        module_name : KWANKGM10070A01,
        is_json : true,
        reception_id : '0',
        reception_cd : null,
        'customers_documents.id': { val: Number(document_id) },
        'customers_documents.update_user_id': { val: Number(login_user_id) },
        'customers_documents.update_user_name': { val: login_user_name },
      });

      if (!response.data.result) {
        throw({ response: response });
      }

      // バリデーションエラーの場合はアラートダイアログを表示する
      if (response.data.response_type === api_response_type.validation) {
        alert(response.data.detail[0].message);
        return;
      }

      // エラーがない場合は完了画面へ遷移する
      location.replace(`${location.origin}${process.env.MIX_MOCK_URL}/customer_document/approval/complete`);
    } catch (error) {
      console.error(error.response.data.message);
      alert(error.response.data.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="maintenance">
      <div className="title">顧客宛文書</div>
      <div className="maintenance_container">
        <div className="contents">
          <div className="page-title">顧客宛文書承認(確認)</div>
          {typeof document_detail === 'object' ? (
            <>
              <table className="detail_table">
                <tbody>
                  <tr>
                    <th>JA名</th>
                    <td>{document_detail.group_name}</td>
                  </tr>
                  <tr>
                    <th>店舗名</th>
                    <td>{document_detail.offices_name}</td>
                  </tr>
                  <tr>
                    <th>タイトル</th>
                    <td>{document_detail.title}</td>
                  </tr>
                  <tr>
                    <th>コメント</th>
                    <td>{document_detail.comment}</td>
                  </tr>
                  <tr>
                    <th>ファイル名</th>
                    <td>{document_detail.file_name}</td>
                  </tr>
                  <tr>
                    <th>対象顧客</th>
                    <td>{document_detail.user_list}</td>
                  </tr>
                  <tr>
                    <th>掲載開始日</th>
                    <td>{document_detail.start_date}</td>
                  </tr>
                  <tr>
                    <th>掲載終了日</th>
                    <td>{document_detail.end_date}</td>
                  </tr>
                  <tr>
                    <th>登録者</th>
                    <td>{document_detail.create_user_name}</td>
                  </tr>
                  <tr>
                    <th>ステータス</th>
                    <td>{document_detail.status}</td>
                  </tr>
                  <tr>
                    <th>直近更新日</th>
                    <td>{document_detail.updated_at}</td>
                  </tr>
                </tbody>
              </table>
            </>
          ) : (
            <></>
          )}
        </div>
        <Row className="footer-button-block mt-3">
          <Col className="footer-btn">
            <a
              className="btn btn-mini btn-outline-success btn-text-color btn-return"
              href={`${location.origin}${process.env.MIX_MOCK_URL}/customer_document/detail?id=${document_id}`}
            >
              戻る
            </a>
          </Col>
          <Col className="footer-btn">
            <a
              className="btn btn-mini btn-success"
              onClick={handleClickConfirm}
            >
              確認
            </a>
          </Col>
        </Row>
      </div>
      <LoadingModal show={is_loading} />
    </div>
  );
};

if (document.getElementById('customer-document-approval-confirm')) {
  render(<CustomerDocumentApprovalConfirm />, document.getElementById('customer-document-approval-confirm'));
}
